import type { MenuItems } from '#payload-types'

export const useNavLinkUri = (item: NonNullable<MenuItems>[number]) => {
  switch (item.link.relationTo) {
    case 'builderPages': {
      const builderPage = useRelationshipField(item.link.value)
      return `/pages/${builderPage.value?.slug}`
    }
    case 'pages': {
      const page = useRelationshipField(item.link.value)
      const uri = page.value?.uri ?? ''

      // `/` is the SA landing on an SA host, so the national home page is the one menu
      // entry the redirect middleware can't tell apart from SA content. Name it
      // absolutely and it leaves the host like every other national link.
      if (uri === '/' && useIsSaHost()) {
        const siteUrl = useRuntimeConfig().public.siteUrl.replace(/\/+$/, '')

        return `${siteUrl}/`
      }

      return uri
    }
    case 'staticPages': {
      const staticPage = useRelationshipField(item.link.value)
      return `/${staticPage.value?.slug}`
    }
    default:
      return ''
  }
}
